<template>

  <b-modal
    id="add-operation-charge-modal"
    :ok-title="$t('Add')"
    :title="$t('Add') + ' ' + typeFraisText"
    ok-only
    centered
    ok-variant="primary"
    @ok="handleOk">

    <div class="row">
      <div :class="hidePercentageModes ? 'col-md-12' : 'col-md-6'">
        <b-form-group
          :label="$t('simulationCharge.Name')"
          class="medium-label mb-4"
          label-for="name-input">
          <b-form-input
            id="name-input"
            v-model="name"
            required
            type="text">
          </b-form-input>
        </b-form-group>
      </div>
      <div v-if="!hidePercentageModes" class="col-md-6">
        <!-- Sélecteur d'unité pour le calcul du TTC -->
        <b-form-group
          :label="$t('operationConstruction.UniteConstruction')"
          class="medium-label mb-4"
          label-for="uniteCharge-input">
          <b-form-select
            id="uniteCharge-input"
            v-model="uniteCharge"
            @change="handleChangeUnite">
            <option
              v-for="option in unitesCharge"
              :key="option.value"
              :value="option.value"
              :disabled="option.value === 'POURCENTAGE_PRIX_REVIENT' && existingPourcentagePrixRevientCount > 0">
              {{ $t(option.text) }}
              <span v-if="option.value === 'POURCENTAGE_PRIX_REVIENT' && existingPourcentagePrixRevientCount > 0">
                ({{ $t('operationCharge.alreadyExists') }})
              </span>
            </option>
          </b-form-select>
        </b-form-group>
      </div>
    </div>

    <!-- Mode UNITAIRE: Saisie HT/TTC selon le contexte -->
    <template v-if="uniteCharge === 'UNITAIRE'">
      <b-form-group
        :label="isHT ? $t('operationCharge.PrixHT') : $t('operationCharge.PrixTTC')"
        class="medium-label mb-4"
        label-for="prixTTC-input">
        <b-input-group :id="'prixTTC-input'">
          <b-form-input
            v-model="prixTTC"
            v-disable-scroll
            min="0"
            step="any"
            type="number">
          </b-form-input>
          <b-input-group-append>{{ isHT ? $t('euros.prixHT') : $t('euros.prixTTC') }}</b-input-group-append>
        </b-input-group>
      </b-form-group>
    </template>

    <!-- Mode POURCENTAGE_COUT_TRAVAUX_HONORAIRE: Pourcentage + TTC auto-calculé -->
    <template v-else-if="uniteCharge === 'POURCENTAGE_COUT_TRAVAUX_HONORAIRE'">
      <div class="row">
        <div class="col-md-6">
          <b-form-group
            :label="$t('operationConstruction.Pourcentage')"
            class="medium-label mb-4"
            label-for="pourcentage-input-travaux-honoraires">
            <b-input-group :id="'pourcentage-input-travaux-honoraires'">
              <b-form-input
                v-model="pourcentage"
                v-disable-scroll
                min="0"
                max="100"
                step="0.01"
                type="number"
                @change="calculatePrixFromPourcentage"
                @input="calculatePrixFromPourcentage">
              </b-form-input>
              <b-input-group-append>%</b-input-group-append>
            </b-input-group>
          </b-form-group>
        </div>
        <div class="col-md-6">
          <b-form-group
            :label="$t('operationConstruction.prixTTC')"
            class="medium-label mb-4"
            label-for="prixTTC-percentage-input-travaux-honoraires">
            <b-input-group :id="'prixTTC-percentage-input-travaux-honoraires'">
              <b-form-input
                v-model="prixTTC"
                disabled
                type="number">
              </b-form-input>
              <b-input-group-append>{{ $t('euros.prixTTC') }}</b-input-group-append>
            </b-input-group>
          </b-form-group>
        </div>
      </div>
    </template>

    <!-- Mode POURCENTAGE_COUT_TRAVAUX: Pourcentage + TTC auto-calculé -->
    <template v-else-if="uniteCharge === 'POURCENTAGE_COUT_TRAVAUX'">
      <div class="row">
        <div class="col-md-6">
          <b-form-group
            :label="$t('operationConstruction.Pourcentage')"
            class="medium-label mb-4"
            label-for="pourcentage-input">
            <b-input-group :id="'pourcentage-input'">
              <b-form-input
                v-model="pourcentage"
                v-disable-scroll
                min="0"
                max="100"
                step="0.01"
                type="number"
                @change="calculatePrixFromPourcentage"
                @input="calculatePrixFromPourcentage">
              </b-form-input>
              <b-input-group-append>%</b-input-group-append>
            </b-input-group>
          </b-form-group>
        </div>
        <div class="col-md-6">
          <b-form-group
            :label="$t('operationConstruction.prixTTC')"
            class="medium-label mb-4"
            label-for="prixTTC-percentage-input">
            <b-input-group :id="'prixTTC-percentage-input'">
              <b-form-input
                v-model="prixTTC"
                disabled
                type="number">
              </b-form-input>
              <b-input-group-append>{{ $t('euros.prixTTC') }}</b-input-group-append>
            </b-input-group>
          </b-form-group>
        </div>
      </div>
    </template>

    <!-- Mode POURCENTAGE_PRIX_REVIENT: Pourcentage + TTC auto-calculé -->
    <template v-else-if="uniteCharge === 'POURCENTAGE_PRIX_REVIENT'">
      <div class="row">
        <div class="col-md-6">
          <b-form-group
            :label="$t('operationConstruction.Pourcentage')"
            class="medium-label mb-4"
            label-for="pourcentage-input-prix-revient">
            <b-input-group :id="'pourcentage-input-prix-revient'">
              <b-form-input
                v-model="pourcentage"
                v-disable-scroll
                min="0"
                max="100"
                step="0.01"
                type="number"
                @change="calculatePrixFromPourcentage"
                @input="calculatePrixFromPourcentage">
              </b-form-input>
              <b-input-group-append>%</b-input-group-append>
            </b-input-group>
          </b-form-group>
        </div>
        <div class="col-md-6">
          <b-form-group
            :label="$t('operationConstruction.prixTTC')"
            class="medium-label mb-4"
            label-for="prixTTC-percentage-input-prix-revient">
            <b-input-group :id="'prixTTC-percentage-input-prix-revient'">
              <b-form-input
                v-model="prixTTC"
                disabled
                type="number">
              </b-form-input>
              <b-input-group-append>{{ $t('euros.prixTTC') }}</b-input-group-append>
            </b-input-group>
          </b-form-group>
        </div>
      </div>
    </template>

  </b-modal>

</template>

<script>

import api from '../../../services/api'

export default {

  name: 'AddOperationChargeModal',

  components: {},

  props: {
    typeFrais: {
      type: Object,
      default: null
    },
    operationId: {
      type: [String, Number],
      default: null
    },
    existingPourcentagePrixRevientCount: {
      type: Number,
      default: 0
    },
    hidePercentageModes: {
      type: Boolean,
      default: false
    },
    isHT: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      name: null,
      uniteCharge: 'UNITAIRE',
      pourcentage: null,
      prixTTC: null
    }
  },

  computed: {

    typeFraisText () {
      return this.typeFrais ? this.$i18n.t(this.typeFrais.text) : ''
    },

    unitesCharge () {
      const baseOptions = [
        { value: 'UNITAIRE', text: 'operationHonoraire.unite.UNITAIRE' }
      ]
      
      if (!this.hidePercentageModes) {
        baseOptions.push(
          { value: 'POURCENTAGE_COUT_TRAVAUX', text: 'unite.construction.enum.POURCENTAGE_COUT_TRAVAUX' },
          { value: 'POURCENTAGE_COUT_TRAVAUX_HONORAIRE', text: 'unite.construction.enum.POURCENTAGE_TRAVAUX_PLUS_HONORAIRES' },
          { value: 'POURCENTAGE_PRIX_REVIENT', text: 'unite.construction.enum.POURCENTAGE_PRIX_REVIENT' }
        )
      }
      
      return baseOptions
    },

    isPercentageMode () {
      return this.uniteCharge === 'POURCENTAGE_COUT_TRAVAUX' ||
             this.uniteCharge === 'POURCENTAGE_COUT_TRAVAUX_HONORAIRE' ||
             this.uniteCharge === 'POURCENTAGE_PRIX_REVIENT'
    }

  },

  emits: ['didAddOperationCharge'],

  methods: {

    handleOk (bvModalEvent) {
      if (!this.name || this.name.trim() === '') {
        bvModalEvent.preventDefault()
        this.$bvToast.toast(this.$i18n.t('MandatoryFields'), {
          autoHideDelay: 3000,
          toaster: 'b-toaster-bottom-right',
          noCloseButton: true,
          variant: 'danger',
          solid: true
        })
        return
      }


      if (this.uniteCharge === 'POURCENTAGE_PRIX_REVIENT' && this.existingPourcentagePrixRevientCount > 0) {
        bvModalEvent.preventDefault()
        this.$bvToast.toast(this.$i18n.t('operationCharge.onlyOnePourcentagePrixRevient'), {
          autoHideDelay: 5000,
          toaster: 'b-toaster-bottom-right',
          noCloseButton: true,
          variant: 'warning',
          solid: true
        })
        return
      }
      if (this.isPercentageMode) {
        if (this.pourcentage === null || this.pourcentage === '' || Number(this.pourcentage) < 0) {
          bvModalEvent.preventDefault()
          this.$bvToast.toast(this.$i18n.t('MandatoryFields'), {
            autoHideDelay: 3000,
            toaster: 'b-toaster-bottom-right',
            noCloseButton: true,
            variant: 'danger',
            solid: true
          })
          return
        }

        if (!this.prixTTC) {
          bvModalEvent.preventDefault()
          this.calculatePrixFromPourcentage()
          return
        }
      }
      this.handleSubmit()
    },

    handleSubmit () {
      if (this.name != null && this.name.trim() !== '') {
        let operationCharge = {
          typeFrais: this.typeFrais,
          name: this.name,
          prixTTC: this.prixTTC,
          uniteCharge: this.uniteCharge,
          pourcentage: this.isPercentageMode ? this.pourcentage : null
        }
        this.$emit('didAddOperationCharge', operationCharge)
      }
      this.resetModal()
      this.hideModal()
    },

    handleChangeUnite () {
      if (this.uniteCharge === 'POURCENTAGE_PRIX_REVIENT' && this.existingPourcentagePrixRevientCount > 0) {
        this.uniteCharge = 'UNITAIRE'
        this.$bvToast.toast(this.$i18n.t('operationCharge.onlyOnePourcentagePrixRevient'), {
          autoHideDelay: 5000,
          toaster: 'b-toaster-bottom-right',
          noCloseButton: true,
          variant: 'warning',
          solid: true
        })
        return
      }

      if (this.uniteCharge === 'UNITAIRE') {
        this.pourcentage = null
        this.prixTTC = null
      } else if (this.uniteCharge === 'POURCENTAGE_COUT_TRAVAUX') {
        this.prixTTC = null
      } else if (this.uniteCharge === 'POURCENTAGE_COUT_TRAVAUX_HONORAIRE') {
        this.prixTTC = null
      } else if (this.uniteCharge === 'POURCENTAGE_PRIX_REVIENT') {
        this.prixTTC = null
      }

      if (this.isPercentageMode && this.pourcentage && Number(this.pourcentage) >= 0) {
        this.calculatePrixFromPourcentage()
      }
    },

    async calculatePrixFromPourcentage () {
      if (!this.operationId || this.pourcentage === null || this.pourcentage === '' || Number(this.pourcentage) < 0) {
        return
      }
      let baseCentimes = 0
      if (this.uniteCharge === 'POURCENTAGE_COUT_TRAVAUX') {
        const resp = await api.get(`/operationConstruction/getCoutTravaux?operationId=${this.operationId}`)
        baseCentimes = resp && resp.data && resp.data.coutTravaux ? resp.data.coutTravaux : 0
      } else if (this.uniteCharge === 'POURCENTAGE_COUT_TRAVAUX_HONORAIRE') {
        const resp = await api.get(`/operationConstruction/getCoutTravauxPlusHonoraires?operationId=${this.operationId}`)
        baseCentimes = resp && resp.data && resp.data.coutTravauxPlusHonoraires ? resp.data.coutTravauxPlusHonoraires : 0
      } else if (this.uniteCharge === 'POURCENTAGE_PRIX_REVIENT') {
        const resp = await api.get(`/operationConstruction/getPrixRevient?operationId=${this.operationId}`)
        baseCentimes = resp && resp.data && resp.data.prixRevient ? resp.data.prixRevient : 0
      }
      const baseEuros = baseCentimes / 100
      const val = Math.round(baseEuros * (Number(this.pourcentage) / 100))
      this.prixTTC = Number(val).toFixed(2)
    },

    resetModal () {
      this.name = null
      this.uniteCharge = 'UNITAIRE'
      this.pourcentage = null
      this.prixTTC = null
    },

    hideModal () {
      this.$bvModal.hide('add-operation-charge-modal')
    }

  }

}

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/operationBilan/components/AddOperationChargeModal.vue